module.exports = __webpack_public_path__ + "media/question2.2e281326.mp3";